module.exports = __webpack_public_path__ + "static/img/bb5.d30de89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bb5.png
// module id = pdP6
// module chunks = 1